import React from "react";
import AboutImage from "../images/a.jpg"; // Replace with your image path

const AboutCircuitcy = () => {
  return (
    <section className="bg-white -mb-4 -mt-2 py-16 px-4 sm:px-8 lg:px-16">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        {/* Text Content */}
        <div className="text-center md:text-left">
          <h2 className="text-3xl sm:text-4xl font-bold text-sky-950 mb-6">
            About Circuitcy
          </h2>
          <div className="text-gray-700 text-justify text-lg leading-relaxed space-y-4">
            <p>
              <strong className="text-sky-950">Circuitcy</strong> is a <span className="text-yellow-500 font-medium">future-focused platform</span> dedicated to transforming engineering education through <span className="text-yellow-500 font-medium">practical, project-based learning</span>.
            </p>

            <ul className="list-disc list-inside space-y-2">
              <li>
                We focus on developing <span className="text-yellow-500 font-medium">real-world skills</span> that go beyond the classroom and align with current <span className="text-yellow-500 font-medium">industry demands</span>.
              </li>
              <li>
                Our programs emphasize <span className="text-yellow-500 font-medium">hands-on training</span>, allowing students to work on <span className="text-yellow-500 font-medium">live projects</span> and gain <span className="text-yellow-500 font-medium">practical experience</span>.
              </li>
              <li>
                We provide learning opportunities across multiple domains including <span className="text-yellow-500 font-medium">Electrical</span>, <span className="text-yellow-500 font-medium">Electronics</span>, <span className="text-yellow-500 font-medium">Mechanical</span>, <span className="text-yellow-500 font-medium">Information Technology</span>, and <span className="text-yellow-500 font-medium">Telecommunications</span>.
              </li>
              <li>
                Our courses are designed and delivered in collaboration with <span className="text-yellow-500 font-medium">experienced professionals</span> from various technical industries.
              </li>
              <li>
                We offer <span className="text-yellow-500 font-medium">career support</span> services such as <span className="text-yellow-500 font-medium">resume development</span>, <span className="text-yellow-500 font-medium">mock interviews</span>, and <span className="text-yellow-500 font-medium">portfolio guidance</span> to help students prepare for job opportunities.
              </li>
              <li>
                Every program includes an <span className="text-yellow-500 font-medium">internship component</span> and concludes with a <span className="text-yellow-500 font-medium">certificate</span> that is recognized in the industry.
              </li>
              <li>
                Our training modules are tailored for students at all levels, from <span className="text-yellow-500 font-medium">early-year learners</span> to <span className="text-yellow-500 font-medium">final-year students</span> preparing for placements.
              </li>
            </ul>

            <p>
              Our goal is to <span className="text-yellow-500 font-medium">bridge the gap</span> between academic knowledge and industry expectations, helping students build strong foundations for their <span className="text-yellow-500 font-medium">careers</span>.
            </p>
          </div>
        </div>

        {/* Image */}
        <div className="flex justify-center">
          <img
            src={AboutImage}
            alt="About Circuitcy"
            className="rounded-2xl shadow-xl hover:shadow-2xl border border-gray-400 w-full max-w-sm md:max-w-md object-cover"
          />
        </div>
      </div>
    </section>
  );
};

export default AboutCircuitcy;
